/**
 * The body of a LICENSE_EXTENDED event is JSON written by the API
 * (LicenseExtendedEventBody on the backend):
 *   { reason: "extended" | "reactivated", years?, previous_expiry,
 *     new_expiry, serial_number?, note? }
 * Returns the parsed details, or null when the body is missing or not that
 * shape so the caller can fall back to showing the raw text.
 */
export function parseLicenseExtension(body) {
  if (!body || typeof body !== "string") return null;

  let details;
  try {
    details = JSON.parse(body);
  } catch (e) {
    return null;
  }

  if (!details || typeof details !== "object" || !details.new_expiry) {
    return null;
  }

  return details;
}
